// extracted by mini-css-extract-plugin
export default {"logo":"navbar_logo__+Kvoe","loginBtn":"navbar_loginBtn__Zhk6r","navlink":"navbar_navlink__JtTPj","dropdownNav":"navbar_dropdownNav__zE5y+"};